import { Button } from "@/components/ui/button";
import type { CategoryColor } from "@/types/recipe";

const colorClasses: Record<
  CategoryColor,
  { selected: string; hover: string; selectedHover: string }
> = {
  primary: {
    selected: "bg-primary text-primary-foreground border-primary",
    hover: "hover:!bg-primary/20 hover:!border-primary/50 hover:!text-primary-foreground",
    selectedHover: "hover:!bg-primary/80 hover:!border-primary/80",
  },
  protein: {
    selected: "bg-protein text-protein-foreground border-protein",
    hover: "hover:!bg-protein/20 hover:!border-protein/50 hover:!text-protein-foreground",
    selectedHover: "hover:!bg-protein/80 hover:!border-protein/80",
  },
  vegetable: {
    selected: "bg-vegetable text-vegetable-foreground border-vegetable",
    hover: "hover:!bg-vegetable/20 hover:!border-vegetable/50 hover:!text-vegetable-foreground",
    selectedHover: "hover:!bg-vegetable/80 hover:!border-vegetable/80",
  },
  side: {
    selected: "bg-side text-side-foreground border-side",
    hover: "hover:!bg-side/20 hover:!border-side/50 hover:!text-side-foreground",
    selectedHover: "hover:!bg-side/80 hover:!border-side/80",
  },
  spice: {
    selected: "bg-spice text-spice-foreground border-spice",
    hover: "hover:!bg-spice/20 hover:!border-spice/50 hover:!text-spice-foreground",
    selectedHover: "hover:!bg-spice/80 hover:!border-spice/80",
  },
  appliance: {
    selected: "bg-appliance text-appliance-foreground border-appliance",
    hover: "hover:!bg-appliance/20 hover:!border-appliance/50 hover:!text-appliance-foreground",
    selectedHover: "hover:!bg-appliance/80 hover:!border-appliance/80",
  },
};

type Props = {
  option: string;
  isSelected: boolean;
  onToggle: () => void;
  category?: CategoryColor;
};

export const MultiSelectButton = ({ option, isSelected, onToggle, category = "primary" }: Props) => {
  const colors = colorClasses[category];
  return (
    <Button
      type="button"
      variant="outline"
      onClick={onToggle}
      className={`transition-all hover:scale-105 ${
        isSelected ? `${colors.selected} ${colors.selectedHover}` : colors.hover
      }`}
    >
      {option}
    </Button>
  );
};
